import { render, staticRenderFns } from "./ModalCreateTemplate.vue?vue&type=template&id=3a320490"
import script from "./ModalCreateTemplate.vue?vue&type=script&lang=js"
export * from "./ModalCreateTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports